"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment, useSubscription } from "@opensea/graphql";
import { cloneDeep, set } from "es-toolkit/compat";
import { useState } from "react";
const UseLiveUpdateCollectionsBestOrdersSubscription = graphql(`
  subscription UseLiveUpdateCollectionsBestOrdersSubscription(
    $slugs: [String!]!
  ) {
    collectionsBySlugs(slugs: $slugs) {
      __typename
      ... on Collection {
        id
        slug
        floorPrice {
          id
          pricePerItem {
            token {
              unit
            }
          }
        }
        topOffer {
          id
          pricePerItem {
            token {
              unit
            }
          }
        }
      }
    }
  }
`);
export const useLiveUpdateCollectionsBestOrdersFragment = graphql(`
  fragment useLiveUpdateCollectionsBestOrders on Collection {
    slug
  }
`);
export function useLiveUpdateCollectionsBestOrders(initialCollections) {
  const $ = _c(5);
  const [collections, setCollections] = useState(initialCollections);
  let t0;
  if ($[0] !== initialCollections) {
    t0 = initialCollections.map(_temp);
    $[0] = initialCollections;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      query: UseLiveUpdateCollectionsBestOrdersSubscription,
      variables: {
        slugs: t0
      }
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      onResult: updateData => {
        if (updateData?.collectionsBySlugs) {
          setCollections(prevCollections => prevCollections.map(prevCollection => {
            const collectionSlug = readFragment(useLiveUpdateCollectionsBestOrdersFragment, prevCollection).slug;
            if (updateData.collectionsBySlugs.__typename !== "Collection" || collectionSlug !== updateData.collectionsBySlugs.slug) {
              return prevCollection;
            }
            const collection = cloneDeep(prevCollection);
            set(collection, "stats.floorPrice.pricePerItem.token.unit", updateData.collectionsBySlugs.floorPrice?.pricePerItem.token.unit);
            set(collection, "stats.topOffer.pricePerItem.token.unit", updateData.collectionsBySlugs.topOffer?.pricePerItem.token.unit);
            return collection;
          }));
        }
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useSubscription(t1, t2);
  return collections;
}
function _temp(collectionKey) {
  return readFragment(useLiveUpdateCollectionsBestOrdersFragment, collectionKey).slug;
}